import React from "react";
import "./Portfolio.css"

const Portfolio = () => {
    return (
        <div id="portfolio">
            <h1 className="title-portfolio">My Portfolio</h1>
            <h2 className="title-portfolio"> Here are a couple of projects that I have worked on. Hope you enjoy them!
            </h2>
            <div id="all-portfolios">
            <div id="flashsheet-container">
                <div id="title-description">
                    <h2>
                        <a href="http://flashsheet.fly.dev">Flashsheet</a>
                    </h2>
                    <p className="description">This is one of my latest projects. Instead of searching through social media for a tattoo artist, this is a platform for artists and people to find one another. In this project, I worked with two others to be able to create the front and backend of this website.</p>
                </div>
                <div id="tools">
                    <h3>Tools Used</h3>
                    <ul className="used">
                        <li>CSS</li>
                        <li>Javascript</li>
                        <li>React</li>
                        <li>Redux ToolKit</li>
                        <li>Stripe</li>
                        <li>PostgreSQL</li>
                        <li>Express</li>
                        <li>Bcrypt</li>
                        <li>Jsonwebstoken</li>
                        <li>Node</li>
                        <li>Nodemon</li>
                    </ul>
                </div>
            </div>
            <div id="tictactoe-container">
                <div id="title-description">
                <h2>
                    <a href="https://anthonypenalozastictactoe.netlify.app/">Tic Tac Toe</a>
                </h2>
                <p className="description">Just like it sounds! I created a website where you are able to play Tic Tac Toe. It was one of my first projects that I had to do on my own using Javascript.</p>
                </div>
                <div id="tools">
                <h3>Tools Used</h3>
                <ul className="used">
                    <li>CSS</li>
                    <li>HTML</li>
                    <li>Javascript</li>
                </ul>
                </div>
            </div>
            </div>
        </div>
    )
}

export default Portfolio;